import React from "react";
import NurseInitialInspection from "../IpEMR/Nurse/NurseInitialInspection/NurseInitialInspection";
import NurseInitialAssessmentFormProvider from "../IpEMR/InspectionForms/HistoryForm/NurseInitialAssessmentFormProvider";
import NurseMedicine from "./NurseMedicine/NurseMedicine";
import MonitoringTabs from "./Monitoring/NurseMonitoring/MonitoringTabs";
import CareItemTabs from "../IpEMR/Nurse/CareItems/CareItemTabs";
import ServicesTabs from "./ReceptionistIp/ServicesIp/ServicesTabs";
import Landing from "../IpEMR/Doctor/Landing/Landing";
import ChatTabs from "./Chat/ChatTabs";
const NurseIP = ({ patientData, params, refreshPage }) => {
  return (
    <>
      {params?.type === "ia" || params?.type === "nurse" ? (
        <NurseInitialAssessmentFormProvider>
          <NurseInitialInspection
            refreshPage={refreshPage}
            editId={patientData?.nurse_initial_assessment}
            patientData={patientData}
          />
        </NurseInitialAssessmentFormProvider>
      ) : params?.type === "monitoring" ? (
        <MonitoringTabs />
      ) : params?.type === "medicine" ? (
        <NurseMedicine patientData={patientData} />
      ) : params?.type === "services" ? (
        <ServicesTabs patientData={patientData} />
      ) : params?.type === "order-sheet" ? (
        <CareItemTabs />
      ) : params?.type === "chat" ? (
        <ChatTabs patientData={patientData} />
      ) : (
        params?.type === "landing" && <Landing />
      )}
    </>
  );
};

export default NurseIP;
